import script from "./SortDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./SortDropdown.vue?vue&type=style&index=0&id=25bcd2e5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25bcd2e5"]])

export default __exports__